(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      if (url.hash) {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-bundle-promotions"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-bundle-promotion-copy]') : null;
    if (!button || !button.dataset.bundlePromotionCopy) return;
    try {
      await navigator.clipboard.writeText(button.dataset.bundlePromotionCopy);
      const check = button.querySelector('[data-copy-check]');
      const feedback = button.parentElement.querySelector('[data-copy-feedback]');
      if (feedback) feedback.textContent = feedback.dataset.success;
      if (check) {
        check.hidden = false;
        window.setTimeout(() => { check.hidden = true; if (feedback) feedback.textContent = ''; }, 1800);
      }
    } catch {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(button.querySelector('strong'));
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-event-calendar"] && !Shopify.designMode) return;
  try {
    
  class NwEventCalendar extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('[data-dialog-content]');
      this.dialogTitle = this.querySelector('[data-dialog-title]');
      this.triggers = [...this.querySelectorAll('[data-calendar-day], [data-calendar-event]')];
      this.hoveredTrigger = null;
      this.triggers.forEach((trigger) => {
        trigger.addEventListener(
          'pointerenter',
          (event) => {
            if (event.pointerType === 'touch') return;
            this.hoveredTrigger = trigger;
            this.updateHighlight();
          },
          { signal }
        );
        trigger.addEventListener(
          'pointerleave',
          () => {
            if (this.hoveredTrigger === trigger) this.hoveredTrigger = null;
            this.updateHighlight();
          },
          { signal }
        );
      });
      this.addEventListener('focusin', this.updateHighlight, { signal });
      this.addEventListener('focusout', this.updateHighlight, { signal });
      this.updateHighlight();
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.triggers.forEach((trigger) => {
        trigger.setAttribute('aria-haspopup', 'dialog');
      });
      this.addEventListener('click', this.handleClick, { signal });
      this.dialog.addEventListener('close', this.handleClose, { signal });
      this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });
      this.addEventListener('shopify:block:deselect', this.close, { signal });
    }

    disconnectedCallback() {
      this.close();
      this.setModalOpen(false);
      this.abortController?.abort();
    }

    getTriggerDay(trigger) {
      return trigger?.dataset.calendarDay || trigger?.closest('[data-event-day]')?.dataset.eventDay;
    }

    updateHighlight = () => {
      const focusedTrigger = this.triggers.find((trigger) => trigger.matches(':focus-visible'));
      const activeDay = this.getTriggerDay(this.hoveredTrigger || focusedTrigger);
      this.triggers.forEach((trigger) => {
        trigger.classList.toggle('is-highlighted', Boolean(activeDay) && this.getTriggerDay(trigger) === activeDay);
      });
    };

    handleClick = (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('[data-calendar-close]') || event.target === this.dialog) {
        this.close();
        return;
      }
      const trigger = event.target.closest('[data-calendar-day], [data-calendar-event]');
      if (!trigger) return;
      event.preventDefault();
      const entries = trigger.hasAttribute('data-calendar-day')
        ? [...this.querySelectorAll('[data-event-day]')].filter(
            (entry) => entry.dataset.eventDay === trigger.dataset.calendarDay
          )
        : [trigger.closest('[data-event-day]')];
      this.open(entries, trigger);
    };

    handleBlockSelect = (event) => {
      const entry = event.target.querySelector('[data-event-day]');
      if (entry) this.open([entry], entry.querySelector('summary'));
    };

    open(entries, trigger) {
      if (!entries.length || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      const articles = entries.map((entry) => entry.querySelector('[data-event-content]').cloneNode(true));
      this.content.replaceChildren(...articles);
      this.dialogTitle.textContent = trigger.dataset.dialogLabel || entries[0].dataset.eventTitle;
      this.activeTrigger = trigger;
      if (!this.dialog.open) this.dialog.showModal();
      this.setModalOpen(true);
      this.dialog.scrollTop = 0;
      this.dialogTitle.focus({ preventScroll: true });
    }

    close = () => {
      if (this.dialog?.open) this.dialog.close();
    };

    // Mirrored on <html> for the page scroll lock: a :has() on <html> would restyle the whole page whenever apps add nodes.
    setModalOpen(open) {
      this.toggleAttribute('data-modal-open', open);
      document.documentElement.toggleAttribute('data-nw-event-calendar-modal-open', open);
    }

    handleClose = () => {
      this.setModalOpen(false);
      if (this.activeTrigger?.isConnected) this.activeTrigger.focus({ preventScroll: true });
      this.content.replaceChildren();
    };
  }

  if (!customElements.get('nw-event-calendar')) customElements.define('nw-event-calendar', NwEventCalendar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-image-grid-popup"] && !Shopify.designMode) return;
  try {
    
  class NwImageGridPopup extends HTMLElement {
    #activeTrigger = null;
    #abortController = new AbortController();
    #imageCache = new Map();
    #ignoreNextOpenClick = false;

    connectedCallback() {
      this.addEventListener('click', this.#handleClick, { signal: this.#abortController.signal, capture: true });
      this.addEventListener('pointerenter', this.#handlePointerEnter, { signal: this.#abortController.signal, capture: true });
      this.addEventListener('focusin', this.#handleFocusIn, { signal: this.#abortController.signal });
      this.addEventListener('touchstart', this.#handleTouchStart, { signal: this.#abortController.signal, passive: true });

      const dialog = this.dialog;
      if (!dialog) return;

      dialog.addEventListener('click', this.#handleDialogClick, { signal: this.#abortController.signal });
      dialog.addEventListener('pointerdown', this.#handleDialogPointerDown, { signal: this.#abortController.signal });
      dialog.addEventListener('keydown', this.#handleDialogKeyDown, { signal: this.#abortController.signal });
      dialog.addEventListener('cancel', this.#handleDialogCancel, { signal: this.#abortController.signal });

      this.prevButton?.addEventListener('click', this.#handlePrevClick, { signal: this.#abortController.signal });
      this.nextButton?.addEventListener('click', this.#handleNextClick, { signal: this.#abortController.signal });
    }

    disconnectedCallback() {
      this.#abortController.abort();
    }

    #handleClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const openButton = target.closest('[data-open-image-popup]');
      if (openButton instanceof HTMLButtonElement) {
        if (this.#ignoreNextOpenClick) {
          this.#ignoreNextOpenClick = false;
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.open(openButton);
        return;
      }

      const closeButton = target.closest('[data-close-image-popup]');
      if (!(closeButton instanceof HTMLButtonElement)) return;

      event.preventDefault();
      this.close();
    };

    #handlePointerEnter = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const openButton = target.closest('[data-open-image-popup]');
      if (!(openButton instanceof HTMLButtonElement)) return;

      this.#preloadImage(openButton);
    };

    #handleFocusIn = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const openButton = target.closest('[data-open-image-popup]');
      if (!(openButton instanceof HTMLButtonElement)) return;

      this.#preloadImage(openButton);
    };

    #handleTouchStart = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const openButton = target.closest('[data-open-image-popup]');
      if (!(openButton instanceof HTMLButtonElement)) return;

      this.#preloadImage(openButton);
    };

    #isBackdropTap = (target) => {
      const dialog = this.dialog;
      if (!dialog || !(target instanceof Node)) return false;
      return target === dialog;
    };

    #handleDialogClick = (event) => {
      if (!this.#isBackdropTap(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      this.#ignoreNextOpenClick = true;
      setTimeout(() => { this.#ignoreNextOpenClick = false; }, 400);
      this.close();
    };

    #handleDialogPointerDown = (event) => {
      if (event.pointerType !== 'touch') return;
      if (!this.#isBackdropTap(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      this.#ignoreNextOpenClick = true;
      setTimeout(() => { this.#ignoreNextOpenClick = false; }, 400);
      this.close();
    };

    #handleDialogCancel = () => {
      if (!this.dialog?.open) return;
      this.#restorePageScroll();
      this.#activeTrigger?.focus();
    };

    #handleDialogKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.#goToPrev();
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.#goToNext();
        return;
      }
    };

    #handlePrevClick = (event) => {
      event.preventDefault();
      this.#goToPrev();
    };

    #handleNextClick = (event) => {
      event.preventDefault();
      this.#goToNext();
    };

    get triggers() {
      return Array.from(this.querySelectorAll('[data-open-image-popup]'));
    }

    #goToPrev() {
      const triggers = this.triggers;
      if (triggers.length < 2) return;
      const currentIndex = this.#activeTrigger ? triggers.indexOf(this.#activeTrigger) : -1;
      const prevIndex = currentIndex <= 0 ? triggers.length - 1 : currentIndex - 1;
      this.open(triggers[prevIndex]);
    }

    #goToNext() {
      const triggers = this.triggers;
      if (triggers.length < 2) return;
      const currentIndex = this.#activeTrigger ? triggers.indexOf(this.#activeTrigger) : -1;
      const nextIndex = currentIndex < 0 || currentIndex >= triggers.length - 1 ? 0 : currentIndex + 1;
      this.open(triggers[nextIndex]);
    }

    #updateNavVisibility() {
      const triggers = this.triggers;
      const hasMultiple = triggers.length > 1;
      if (this.prevButton) {
        if (hasMultiple) this.prevButton.removeAttribute('hidden');
        else this.prevButton.setAttribute('hidden', '');
      }
      if (this.nextButton) {
        if (hasMultiple) this.nextButton.removeAttribute('hidden');
        else this.nextButton.setAttribute('hidden', '');
      }
    }

    open(trigger) {
      const dialog = this.dialog;
      const activeImage = this.activeImage;
      const activeLabel = this.activeLabel;
      if (!dialog || !activeImage || !activeLabel) return;

      const imageUrl = trigger.dataset.imageUrl;
      if (!imageUrl) return;

      const imageAlt = trigger.dataset.imageAlt || trigger.getAttribute('aria-label') || '';
      const imageWidth = trigger.dataset.imageWidth;
      const imageHeight = trigger.dataset.imageHeight;
      const imageWidthNumber = Number(imageWidth);
      const imageHeightNumber = Number(imageHeight);
      const previewImage = trigger.querySelector('img');
      const previewSrc =
        previewImage instanceof HTMLImageElement ? previewImage.currentSrc || previewImage.src || imageUrl : imageUrl;

      this.#activeTrigger = trigger;


      activeImage.src = previewSrc;
      activeImage.alt = imageAlt;
      activeLabel.textContent = imageAlt || trigger.getAttribute('aria-label') || '';

      if (imageWidth && !Number.isNaN(imageWidthNumber)) {
        activeImage.width = imageWidthNumber;
      } else {
        activeImage.removeAttribute('width');
      }

      if (imageHeight && !Number.isNaN(imageHeightNumber)) {
        activeImage.height = imageHeightNumber;
      } else {
        activeImage.removeAttribute('height');
      }

      if (!Number.isNaN(imageWidthNumber) && !Number.isNaN(imageHeightNumber) && imageHeightNumber > 0) {
        activeImage.style.setProperty('--nw-image-grid-popup-image-ratio', `${imageWidthNumber / imageHeightNumber}`);
        activeImage.style.aspectRatio = `${imageWidthNumber} / ${imageHeightNumber}`;
      } else {
        activeImage.style.removeProperty('--nw-image-grid-popup-image-ratio');
        activeImage.style.removeProperty('aspect-ratio');
      }

      if (!dialog.open) {
        // Same page lock as dialog.js (`html[data-dialog-open]` in base.css): fixing the body resets the page scroll
        // to 0, and iOS Safari then brings back its collapsed toolbars. Any scroll caused by the autofocus is undone
        // in the same frame.
        const root = document.documentElement;
        const scrollY = window.scrollY;
        root.setAttribute('data-dialog-open', '');
        root.style.scrollBehavior = 'auto';
        dialog.showModal();
        if (window.scrollY !== scrollY) window.scrollTo({ top: scrollY, behavior: 'instant' });
        root.style.removeProperty('scroll-behavior');
      }

      this.#updateNavVisibility();

      // preventScroll: WebKit can scroll the page to "reveal" an element of a fixed dialog when the toolbars are
      // collapsed, which brings them back on iOS Safari.
      requestAnimationFrame(() => {
        activeLabel.focus({ preventScroll: true });
      });

      if (previewSrc === imageUrl) return;

      this.#preloadImage(trigger).then((loadedImage) => {
        if (this.#activeTrigger !== trigger) return;
        if (!(loadedImage instanceof HTMLImageElement)) return;

        activeImage.src = loadedImage.src;
      });
    }

    close() {
      const dialog = this.dialog;
      if (!dialog?.open) return;

      this.#restorePageScroll();
      dialog.close();
      this.#activeTrigger?.focus();
    }

    get dialog() {
      const dialog = this.querySelector('[data-ref="dialog"]');
      return dialog instanceof HTMLDialogElement ? dialog : null;
    }

    get activeImage() {
      const image = this.querySelector('[data-ref="activeImage"]');
      return image instanceof HTMLImageElement ? image : null;
    }

    get activeLabel() {
      const label = this.querySelector('[data-ref="activeLabel"]');
      return label instanceof HTMLElement ? label : null;
    }

    get closeButton() {
      const button = this.querySelector('[data-ref="closeButton"]');
      return button instanceof HTMLButtonElement ? button : null;
    }

    get prevButton() {
      const button = this.querySelector('[data-ref="prevButton"]');
      return button instanceof HTMLButtonElement ? button : null;
    }

    get nextButton() {
      const button = this.querySelector('[data-ref="nextButton"]');
      return button instanceof HTMLButtonElement ? button : null;
    }

    #preloadImage(trigger) {
      const imageUrl = trigger.dataset.imageUrl;
      if (!imageUrl) return Promise.resolve(null);

      if (this.#imageCache.has(imageUrl)) {
        return this.#imageCache.get(imageUrl);
      }

      const imagePromise = new Promise((resolve) => {
        const image = new Image();
        image.decoding = 'async';
        image.fetchPriority = 'high';

        image.onload = () => resolve(image);
        image.onerror = () => resolve(null);
        image.src = imageUrl;
      });

      this.#imageCache.set(imageUrl, imagePromise);
      return imagePromise;
    }

    #restorePageScroll() {
      // Keep the lock while another modal dialog is still open. This also runs on `cancel`, before this one closes.
      const otherModalOpen = [...document.querySelectorAll('dialog[open]:modal')].some((open) => open !== this.dialog);
      if (!otherModalOpen) document.documentElement.removeAttribute('data-dialog-open');
    }
  }

  if (!customElements.get('nw-image-grid-popup')) {
    customElements.define('nw-image-grid-popup', NwImageGridPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-promo-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nw-promo-bar')) {
    customElements.define(
      'nw-promo-bar',
      class NwPromoBar extends HTMLElement {
        /** Marquee speed in pixels per second for each "speed" setting step. */
        static PIXELS_PER_SECOND = { 1: 35, 2: 55, 3: 80 };

        connectedCallback() {
          if (this.#isOutsideWindow()) {
            this.hidden = true;
            return;
          }

          if (this.classList.contains('nw-promo-bar--marquee')) this.#setUpMarquee();
          if (this.dataset.countdownEnd) this.#startCountdown();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          clearInterval(this.countdownTimer);
        }

        /** Hides the bar before its start or after its end (pages can be served from cache). */
        #isOutsideWindow() {
          if (this.hasAttribute('data-design-mode')) return false;
          const now = Date.now() / 1000;
          const from = Number(this.dataset.showFrom || 0);
          const until = Number(this.dataset.hideAfter || 0);
          return (from > 0 && now < from) || (until > 0 && now >= until);
        }

        #setUpMarquee() {
          const groups = /** @type {HTMLElement[]} */ ([...this.querySelectorAll('[data-promo-group]')]);
          if (groups.length !== 2) return;

          const originals = [...groups[0].children].map((message) => message.cloneNode(true));
          const fill = () => {
            const barWidth = this.getBoundingClientRect().width;
            if (!barWidth || originals.length === 0) return;

            // Repeat the messages until each group is at least as wide as the bar, so the loop has no gap.
            for (const group of groups) {
              group.replaceChildren(...originals.map((message) => message.cloneNode(true)));
              let safety = 20;
              while (group.getBoundingClientRect().width < barWidth && safety-- > 0) {
                group.append(...originals.map((message) => message.cloneNode(true)));
              }
            }
            groups[1].querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));

            const speed = getComputedStyle(this).getPropertyValue('--nw-promo-speed').trim();
            const pixelsPerSecond = NwPromoBar.PIXELS_PER_SECOND[speed] ?? NwPromoBar.PIXELS_PER_SECOND[2];
            const duration = groups[0].getBoundingClientRect().width / pixelsPerSecond;
            this.style.setProperty('--nw-promo-duration', `${duration.toFixed(2)}s`);
          };

          let lastWidth = 0;
          this.resizeObserver = new ResizeObserver(([entry]) => {
            const width = Math.round(entry.contentRect.width);
            if (width === lastWidth) return;
            lastWidth = width;
            fill();
          });
          this.resizeObserver.observe(this);
        }

        #startCountdown() {
          const end = Number(this.dataset.countdownEnd) * 1000;
          const value = this.querySelector('[data-countdown-value]');
          if (!value) return;

          const pad = (/** @type {number} */ number) => String(number).padStart(2, '0');
          const tick = () => {
            const secondsLeft = Math.max(0, Math.floor((end - Date.now()) / 1000));
            if (secondsLeft === 0 && !this.hasAttribute('data-design-mode')) {
              clearInterval(this.countdownTimer);
              this.hidden = true;
              return;
            }
            const days = Math.floor(secondsLeft / 86400);
            const hours = Math.floor((secondsLeft % 86400) / 3600);
            const minutes = Math.floor((secondsLeft % 3600) / 60);
            const seconds = secondsLeft % 60;
            value.textContent = `${days > 0 ? `${days}d ` : ''}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
          };

          tick();
          this.countdownTimer = setInterval(tick, 1000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
